import React from 'react';
import { Link } from 'react-router-dom';
import CanonicalURL from '../components/CanonicalURL';
import ContactFormBox from '../components/ContactFormBox';

const PrivacyPage = () => {
  return (
    <>
      <CanonicalURL url="https://wealthcore.app/privacy" />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="text-blue-600 hover:underline text-sm mb-6 inline-block">← Back to Home</Link>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
          <p className="text-gray-500 text-sm mb-8">Last updated: February 2026</p>

          <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">1. Information We Collect</h2>
              <p>We collect information you provide directly: email, name, password (hashed), and financial data you enter (expenses, income, properties, tax information, stock analysis preferences, and investment data). We also collect usage data and technical information (IP address, device type) to operate and improve the Service.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">2. How We Use Your Information</h2>
              <p>We use your information to provide, maintain, and improve the Service; to process transactions; to communicate with you; and to comply with legal obligations. We do not sell your personal information to third parties.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">3. Data Security</h2>
              <p>We use industry-standard measures to protect your data, including encryption in transit and at rest. Passwords are hashed. However, no method of transmission over the internet is 100% secure. <strong>We do not warrant or guarantee absolute security.</strong> You use the Service and transmit data at your own risk.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">4. Data Sharing</h2>
              <p>We do not sell, rent, or share your personal or financial data with third parties for marketing. We may share data with service providers (hosting, email) who assist in operating the Service under strict confidentiality. We may disclose data if required by law or to protect our rights.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">5. Data Retention</h2>
              <p>We retain your data for as long as your account is active or as needed to provide the Service. You may request deletion of your account and data by contacting us.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">6. Your Rights</h2>
              <p>You may access, correct, or delete your personal data through your account settings or by contacting us. Depending on your location, you may have additional rights under applicable privacy laws.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">7. Cookies and Tracking</h2>
              <p>We use essential cookies and similar technologies to operate the Service (e.g., authentication). We may use device fingerprinting for security and bot protection during registration and login. We do not use third-party advertising cookies.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">8. Changes</h2>
              <p>We may update this Privacy Policy from time to time. We will notify you of material changes by posting the updated policy on this page and updating the &quot;Last updated&quot; date.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">9. Contact</h2>
              <p>Questions about privacy? Use the form below or contact us at <Link to="/help#contact-form" className="text-blue-600 hover:underline">support@wealthcore.app</Link>.</p>
            </section>
          </div>

          {/* Privacy Policy Contact Form */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <ContactFormBox
              title="Privacy Questions"
              subtitle="Have a question about our Privacy Policy or your data? Send us a message and we'll get back to you within 24 hours."
              fixedSubject="Privacy Policy"
            />
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <Link to="/" className="text-blue-600 hover:underline">← Back to Home</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPage;
